export const CATEGORIES = [
  "General Workers",
  "Kitchen & Hospitality",
  "Loading / Unloading",
  "Car Spare Parts",
  "Forklift Driver",
  "Operation Manager",
  "Barber Community",
  "Barber Shop Owner",
  "Lathe Machine",
  "Messenger Leads",
];

export const CANDIDATE_STATUSES = [
  "New", "Called", "Interested", "Not Interested", "Placed", "Rejected", "Follow Up", "No Answer", "Do Not Call",
];

export const LEAD_STATUSES = [
  "New", "Contacted", "Qualified", "Meeting Scheduled", "Proposal Sent", "Won", "Lost", "Nurture",
];

export const LEAD_SOURCES = ["Cold Call", "WhatsApp", "Referral", "Website", "Walk-in", "Other"];
export const LEAD_PRIORITIES = ["Low", "Medium", "High", "Urgent"];

export const CLIENT_STATUSES = ["Not Contacted", "Contacted", "Interested", "Rejected", "Customer", "Do Not Call"];

export const COUNTRY_CODES = {
  malaysia: "MY", indian: "IN", india: "IN", bangladesh: "BD", nepal: "NP",
  indonesia: "ID", myanmar: "MM", pakistan: "PK", philippines: "PH", sri_lanka: "LK", vietnam: "VN",
};

export function countryChip(country) {
  if (!country) return "—";
  const key = country.toLowerCase().trim();
  return COUNTRY_CODES[key] || country.slice(0, 2).toUpperCase();
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  } catch { return "—"; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
}

export function statusBadgeColor(status) {
  const map = {
    New: "#3b82f6", Called: "#06b6d4", Interested: "#10b981",
    "Not Interested": "#64748b", Placed: "#10b981", Rejected: "#ef4444",
    "Follow Up": "#f59e0b", "No Answer": "#94a3b8",
    Contacted: "#06b6d4", Qualified: "#10b981", "Meeting Scheduled": "#8b5cf6",
    "Proposal Sent": "#f59e0b", Won: "#10b981", Lost: "#ef4444", Nurture: "#64748b",
    "Not Contacted": "#64748b", Customer: "#10b981", "Do Not Call": "#ef4444",
  };
  return map[status] || "#94a3b8";
}

export function priorityColor(p) {
  return { Low: "#64748b", Medium: "#3b82f6", High: "#f59e0b", Urgent: "#ef4444" }[p] || "#64748b";
}

export function whatsappLink(phone, message = "") {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return null;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}
